import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreMessageSource } from '../../../Types/StoreTypes';

const initialState: StoreMessageSource = {
    messageIdentifier: '',
    isOpen: false,
    content: [],
};

const messageSourceSlice = createSlice({
    name: 'messageSource',
    initialState,
    reducers: {
        setMessageSource: (state, action: PayloadAction<StoreMessageSource>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setMessageSource } = messageSourceSlice.actions;

export default messageSourceSlice.reducer;
